// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"441":"9c487b98","659":"1bac233a","890":"861f14e0"}[chunkId] + ".chunk.css";
};